import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../../shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const CreditNoteVerificationModalTable = ({ title, reactTableData, ReactTableActions, removePatientFromInvoice, exceptionsPatients, addPatientFromInvoice }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        withSearchEngine,
        placeholder: 'Buscar Paciente',
        manualPageSize: [5],
        useActions: true,
        actions: (data) => ReactTableActions({ data,exceptionsPatients,removePatientFromInvoice, addPatientFromInvoice })
    };

    const columnsData = [
        {
            Header: "Nombre del Paciente",
            accessor: 'nombre_paciente',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Documento del Paciente",
            accessor: 'documento_paciente',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Codigo de Autorización",
            accessor: 'codigo_autorizacion',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Entidad",
            accessor: 'nombre_tercero',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Numero de Contrato",
            accessor: 'numero_contrato',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Regimen",
            accessor: 'regimen_nombre',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

CreditNoteVerificationModalTable.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default CreditNoteVerificationModalTable;
